import { useQuery } from '@tanstack/react-query'
import React, { useState } from 'react'
import {
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material'
import LeadHeader from '../../../components/LeadHeader/LeadHeader'
import PageLoading from '../../../components/PageLoading/PageLoading'
import { useNotification } from '../../../context/NotificationManager/NotificationManager'
import { dateTimeToString } from '../../../utils/date'
import useLead from '../../../hooks/useLead'
import ModalTranscripcionLlamada from '../../../modals/ModalTranscripcionLlamada/ModalTranscripcionLlamada'
import {
  formatDuration,
  getEstadoRespuestaLlamada
} from '../../../utils/model/llamadas'
import { getLlamadasLead } from '../../../utils/api/llamadas'
import css from './Llamadas.module.css'

const Llamadas = () => {
  const { id } = useLead()
  const notification = useNotification()

  const [expandedCalls, setExpandedCalls] = useState({})
  const [llamadaSeleccionada, setLlamadaSeleccionada] = useState(null)

  const { isLoading, data: llamadas = [] } = useQuery({
    queryKey: ['llamada', 'list', 'feedback', id],
    queryFn: () =>
      getLlamadasLead(id).catch(err => {
        notification.error({
          title: 'Error al recuperar las llamadas',
          content: err
        })
        return []
      })
  })

  const toggleExpand = id => {
    setExpandedCalls(prev => ({ ...prev, [id]: !prev[id] }))
  }

  return (
    <PageLoading isLoading={isLoading}>
      <div className={css.main}>
        <LeadHeader label='Llamadas' />
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Fecha</TableCell>
                <TableCell>Tipo</TableCell>
                <TableCell>Estado</TableCell>
                <TableCell>Respuesta</TableCell>
                <TableCell align='center'>Duración</TableCell>
                <TableCell>Usuario</TableCell>
                <TableCell align='center'>Acciones</TableCell>
                <TableCell align='center'></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {llamadas.length === 0 && (
                <TableRow>
                  <TableCell colSpan={8} align='center'>
                    No hay llamadas
                  </TableCell>
                </TableRow>
              )}
              {llamadas.map(llamada => (
                <React.Fragment key={llamada.id}>
                  <TableRow className={css.row} hover>
                    <TableCell>
                      {dateTimeToString(llamada.fechaInicio) || '--'}
                    </TableCell>
                    <TableCell>
                      {llamada.tipoLlamada?.replace('LLAMADA_', '') || '--'}
                    </TableCell>
                    <TableCell>{llamada.estadoLlamada || '--'}</TableCell>
                    <TableCell>{getEstadoRespuestaLlamada(llamada)}</TableCell>
                    <TableCell align='center'>
                      {formatDuration(llamada.duracionLlamada)}
                    </TableCell>
                    <TableCell>{llamada.usuario?.nombre || '--'}</TableCell>
                    <TableCell align='center'>
                      <div className={css.actions}>
                        <IconButton
                          color='primary'
                          size='small'
                          onClick={() => setLlamadaSeleccionada(llamada)}
                          title='Ver transcripción completa'
                        >
                          <i className='material-icons'>description</i>
                        </IconButton>
                      </div>
                    </TableCell>
                    <TableCell align='center'>
                      <IconButton
                        size='small'
                        onClick={() => toggleExpand(llamada.id)}
                        title='Ver resumen'
                      >
                        <i className='material-icons'>
                          {expandedCalls[llamada.id]
                            ? 'keyboard_arrow_up'
                            : 'keyboard_arrow_down'}
                        </i>
                      </IconButton>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={css.collapse} colSpan={8}>
                      <Collapse
                        in={!!expandedCalls[llamada.id]}
                        timeout='auto'
                        unmountOnExit
                      >
                        <div className={css.resumen}>
                          <p className={css.text}>
                            {llamada.resumen ||
                              'No hay resumen disponible para esta llamada'}
                          </p>
                        </div>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <ModalTranscripcionLlamada
          open={!!llamadaSeleccionada}
          onClose={() => setLlamadaSeleccionada(null)}
          llamada={llamadaSeleccionada}
        />
      </div>
    </PageLoading>
  )
}

export default Llamadas
